import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSession } from '../lib/session.js';

// Solange /v1/auth/me lädt: Platzhalter statt Flackern. Kein User → /login. Sonst: children.
export function AuthGuard({ children }: { children: ReactNode }) {
  const { user, loading } = useSession();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-bg-page">
        <div
          className="h-8 w-8 animate-spin rounded-full border-2 border-brand-accent border-t-transparent"
          role="status"
          aria-label="loading"
        />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
